/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';

import IconSelectInputComponent from './advisory-flow-inputs/icon-select/IconSelectInputComponent';
import MultiSelectSimpleInputComponent from './advisory-flow-inputs/multiselect-simple/MultiselectSimpleInputComponent';
import AmountInputPicker from './advisory-flow-inputs/amount/AmountInputPicker';
import AnnexesInputPicker from './advisory-flow-inputs/annexes/AnnexesInputPicker';
import CompanyRegistrationInputPicker from './advisory-flow-inputs/company-search/CompanyRegistrationInputPicker';
import CheckboxInputPicker from './advisory-flow-inputs/checkbox/CheckboxInputPicker';
import CurrencyInputPicker from './advisory-flow-inputs/currency/CurrencyInputPicker';
import DateInputPicker from './advisory-flow-inputs/date/DateInputPicker';
import HomeInputPicker from './advisory-flow-inputs/home/HomeInputPicker';
import KilometerSliderInputPicker from './advisory-flow-inputs/slider/KilometerSliderInputPicker';
import PercentageInputPicker from './advisory-flow-inputs/percentage/PercentageInputPicker';
import RadioInputPicker from './advisory-flow-inputs/radio/RadioInputPicker';
import SecuritySystemInputPicker from './advisory-flow-inputs/security-system/SecuritySystemInputPicker';
import SingleCheckboxInputPicker from './advisory-flow-inputs/single-checkbox/SingleCheckboxInputPicker';
import TelephoneNumberInputPicker from './advisory-flow-inputs/telephone-number/TelephoneNumberInputPicker';
import HiddenInputComponent from './advisory-flow-inputs/hidden/HiddenInputComponent';

import { FlowsQuestion } from '../../types/FlowsTypes';
import SelectDetailedInputComponent from './advisory-flow-inputs/select-detailed/SelectDetailedInputComponent';
import { Inputs } from '../../types/Enums';
import MultiLineInputComponent from './company-scan-inputs/multiline/MultiLineInputComponent';
import UnitInputComponent from './company-scan-inputs/unit/UnitInputComponent';
import AmountInputComponent from './company-scan-inputs/amount/AmountInputComponent';
import MultiselectInputComponent from './company-scan-inputs/multiselect/MultiselectInputComponent';
import LinkInputComponent from './company-scan-inputs/link/LinkInputComponent';
import AccidentInputComponent from './company-scan-inputs/accident/AccidentInputComponent';
import CompanyLoanInputComponent from './company-scan-inputs/company-loan/CompanyLoanInputComponent';
import CompanyLeaseInputComponent from './company-scan-inputs/company-lease/CompanyLeaseInputComponent';
import CompanyInvestmentInputComponent from './company-scan-inputs/company-investment/CompanyInvestmentInputComponent';
import SelectInputComponent from './company-scan-inputs/select/SelectInputComponent';
import UnitsInputComponent from './company-scan-inputs/units/UnitsInputComponent';
import ClaimsInputComponent from './company-scan-inputs/claims/ClaimsInputComponent';
import NaceCodeInputComponent from './company-scan-inputs/nace-input/NaceCodeInputComponent';
import GbiCodeInputComponent from './company-scan-inputs/gbi-input/GbiCodeInputComponent';
import LinksInputComponent from './company-scan-inputs/links/LinksInputComponent';
import MaskedInputComponent from './company-scan-inputs/masked/MaskedInputComponent';
import TableInputComponent from './company-scan-inputs/table/components/TableInputComponent';
import NotesInputComponent from './company-scan-inputs/notes/NotesInputComponent';
import IndexMultiselectInputComponent from './company-scan-inputs/index/index-multiselect/IndexMultiselectInputComponent';
import DatetimeInputComponent from './company-scan-inputs/datetime/DatetimeInputComponent';
import AddressInputComponentPicker from './company-scan-inputs/address/AddressInputComponentPicker';
import IndexSelectInputComponent from './company-scan-inputs/index/index-select/IndexSelectInputComponent';
import NumberPlateInputComponent from './company-scan-inputs/number-plate/NumberPlateInputComponent';
import IndexPercentageInputComponent from './company-scan-inputs/index/index-percentage/IndexPercentageInputComponent';
import TextInputComponent from './company-scan-inputs/input/TextInputComponent';
import RichTextInputComponent from './rich-text/RichTextInputComponent';

interface InputProps {
  question: FlowsQuestion;
}

/**
 * TODO: Pickers should be removed and should only be used in case that the
 * input component is dependant on a variable other than the flow id
 */
const smeScanInputComponents = {
  // Separate component for data test id
  [Inputs.INPUT]: (props: InputProps) => <TextInputComponent {...props} />,
  [Inputs.SELECT]: (props: InputProps) => <SelectInputComponent {...props} />,
  [Inputs.DATE]: (props: InputProps) => <DateInputPicker {...props} />,
  [Inputs.CHECKBOX]: (props: InputProps) => <CheckboxInputPicker {...props} />,
  [Inputs.SINGLE_CHECKBOX]: (props: InputProps) => (
    <SingleCheckboxInputPicker {...props} />
  ),
  [Inputs.ADDRESS]: (props: InputProps) => (
    <AddressInputComponentPicker {...props} />
  ),
  [Inputs.TELEPHONE_NUMBER]: (props: InputProps) => (
    <TelephoneNumberInputPicker {...props} />
  ),
  [Inputs.CAR]: (props: InputProps) => <div />,
  [Inputs.ACCIDENT]: (props: InputProps) => (
    <AccidentInputComponent {...props} />
  ),
  [Inputs.HOME]: (props: InputProps) => <HomeInputPicker {...props} />,
  [Inputs.PERCENTAGE]: (props: InputProps) => (
    <PercentageInputPicker {...props} />
  ),
  [Inputs.CURRENCY]: (props: InputProps) => <CurrencyInputPicker {...props} />,
  [Inputs.ANNEXES]: (props: InputProps) => <AnnexesInputPicker {...props} />,
  [Inputs.ROOM]: (props: InputProps) => <AmountInputPicker {...props} />,
  [Inputs.SECURITY_SYSTEM]: (props: InputProps) => (
    <SecuritySystemInputPicker {...props} />
  ),
  [Inputs.MULTISELECT]: (props: InputProps) => (
    <MultiselectInputComponent {...props} />
  ),
  [Inputs.MULTISELECT_DETAILED]: (props: InputProps) => (
    <MultiselectInputComponent {...props} />
  ),
  [Inputs.MULTISELECT_SIMPLE]: (props: InputProps) => (
    <MultiSelectSimpleInputComponent {...props} />
  ),
  [Inputs.SLIDER]: (props: InputProps) => (
    <KilometerSliderInputPicker {...props} />
  ),
  [Inputs.ICON_SELECT]: (props: InputProps) => (
    <IconSelectInputComponent {...props} />
  ),
  [Inputs.SELECT_DETAILED]: (props: InputProps) => (
    <SelectDetailedInputComponent {...props} />
  ),
  [Inputs.LINK]: (props: InputProps) => <LinkInputComponent {...props} />,
  [Inputs.MASKED]: (props: InputProps) => <MaskedInputComponent {...props} />,
  [Inputs.COMPANY_SEARCH]: (props: InputProps) => (
    <CompanyRegistrationInputPicker {...props} />
  ),
  [Inputs.RADIO]: (props: InputProps) => <RadioInputPicker {...props} />,
  [Inputs.AMOUNT]: (props: InputProps) => <AmountInputComponent {...props} />,
  [Inputs.MULTILINE]: (props: InputProps) => (
    <MultiLineInputComponent {...props} />
  ),
  [Inputs.RICH_TEXT]: (props: InputProps) => (
    <RichTextInputComponent {...props} />
  ),
  [Inputs.UNIT]: (props: InputProps) => <UnitInputComponent {...props} />,
  [Inputs.COMPANY_LOAN]: (props: InputProps) => (
    <CompanyLoanInputComponent {...props} />
  ),
  [Inputs.COMPANY_LEASE]: (props: InputProps) => (
    <CompanyLeaseInputComponent {...props} />
  ),
  [Inputs.COMPANY_INVESTMENT]: (props: InputProps) => (
    <CompanyInvestmentInputComponent {...props} />
  ),
  [Inputs.UNITS]: (props: InputProps) => <UnitsInputComponent {...props} />,
  [Inputs.CLAIMS]: (props: InputProps) => <ClaimsInputComponent {...props} />,
  [Inputs.NACE_CODE]: (props: InputProps) => (
    <NaceCodeInputComponent {...props} />
  ),
  [Inputs.GOUDSE_SBI_CODE]: (props: InputProps) => (
    <GbiCodeInputComponent {...props} />
  ),
  [Inputs.LINKS]: (props: InputProps) => (
    <LinksInputComponent isEditable {...props} />
  ),
  [Inputs.TABLE]: (props: InputProps) => <TableInputComponent {...props} />,
  [Inputs.NOTES]: (props: InputProps) => <NotesInputComponent {...props} />,
  [Inputs.INDEX_SELECT]: (props: InputProps) => (
    <IndexSelectInputComponent {...props} />
  ),
  [Inputs.INDEX_MULTISELECT]: (props: InputProps) => (
    <IndexMultiselectInputComponent {...props} />
  ),
  [Inputs.INDEX_PERCENTAGE]: (props: InputProps) => (
    <IndexPercentageInputComponent {...props} />
  ),
  [Inputs.DATETIME]: (props: InputProps) => (
    <DatetimeInputComponent {...props} />
  ),
  [Inputs.NUMBER_PLATE]: (props: InputProps) => (
    <NumberPlateInputComponent {...props} />
  ),
  [Inputs.HIDDEN]: (props: InputProps) => <HiddenInputComponent {...props} />,
};

export default smeScanInputComponents;
